import React, { useState } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { TVChartContainer } from './components/TVChartContainer';
import { TvLiquidationsContainer } from './components/TvLiquidationsContainer';
import { PumpDumpContainer } from './components/PumpDumpContainer';
import { HeatMapContainer } from './components/HeatMapContainer';
import { ChatGptContainer } from './components/ChatGptContainer';
import { ReactComponent as HomeIcon } from './assets/home.svg';
import { ReactComponent as ChartIcon } from './assets/chart.svg';
import { ReactComponent as FlashIcon } from './assets/flash.svg';
import { ReactComponent as TradeIcon } from './assets/trade.svg';
import { ReactComponent as MessagesIcon } from './assets/messages-2.svg';
import "./App.css";


const Login = () => {
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [error, setError] = useState('');
	const navigate = useNavigate();
	// const loginUrl = 'http://localhost:8080/api/auth/login';
	const loginUrl = 'https://tkachev-trade.com/api/auth/login';

	const handleLogin = async (e) => {
		e.preventDefault();
		setError('');
		try {
			const response = await fetch(loginUrl, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ username, password })
			});

			const data = await response.json();
			if (response.ok) {
				localStorage.setItem('token', data.response);
				navigate('/chart/');
			} else {
				setError(data.message || 'Authentication failed');
			}
		} catch (error) {
          setError(`Network error: ${error.message || error}`);
		}
	};

	return (
		<div className="login-container">
			<h2>Login</h2>
			<form onSubmit={handleLogin} className="login-form" >
				<input type="text" placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} required className="login-input" />
				<input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required className="login-input" />
				<button type="submit" className="login-button">Login</button>
			</form>
			{error && <p className="error-message">{error}</p>}
		</div>
	);
};

const PrivateRoute = ({ children }) => {
	return localStorage.getItem('token') ? children : <Navigate to="/" />;
};

const CHART_TABS = [
	{ id: 'volumes', label: 'Vol', icon: 'home' },
	{ id: 'liquidations', label: 'Liq', icon: 'chart' },
	{ id: 'pump-dump', label: 'Pump', icon: 'flash' },
	{ id: 'heatmap', label: 'Heat', icon: 'trade' },
	{ id: 'gpt-analysis', label: 'GPT', icon: 'messages-2' },
];

const NavIcon = ({ iconType, isActive }) => {
	const color = isActive ? '#FF7300' : '#FFFFFF';
	
	const iconProps = {
		width: '24px',
		height: '24px',
		style: { 
			fill: color, 
			stroke: color,
			color: color
		}
	};

	switch (iconType) {
		case 'home':
			return <HomeIcon {...iconProps} />;
		case 'chart':
			return <ChartIcon {...iconProps} />;
		case 'flash':
			return <FlashIcon {...iconProps} />;
		case 'trade':
			return <TradeIcon {...iconProps} />;
		case 'messages-2':
			return <MessagesIcon {...iconProps} />;
		default:
			return null;
	}
};

const ChartPage = () => {
	const [activeTab, setActiveTab] = useState('volumes');
	const renderActiveTab = () => {
		switch (activeTab) {
			case 'liquidations':
				return <TvLiquidationsContainer />;
			case 'pump-dump':
				return <PumpDumpContainer />;
			case 'heatmap':
				return <HeatMapContainer />;
			case 'gpt-analysis':
				return <ChatGptContainer />;
			case 'volumes':
			default:
				return <TVChartContainer />;
		}
	};
	return (
		<div className="chart-page">
			<div className="chart-content">
				{renderActiveTab()}
			</div>
			<div className="chart-nav">
				<div className="nav-container">
					{CHART_TABS.map((tab) => (
						<button
							key={tab.id}
							type="button"
							onClick={() => setActiveTab(tab.id)}
							className={`nav-button${activeTab === tab.id ? ' is-active' : ''}`}
							data-icon={tab.icon}
							style={{ color: activeTab === tab.id ? '#FF7300' : '#FFFFFF' }}
						>
							<NavIcon iconType={tab.icon} isActive={activeTab === tab.id} />
						</button>
					))}
				</div>
			</div>
		</div>
	);
};

const App = () => {
	return (
		<Routes>
			<Route path="/" element={<Login />} />
			<Route path="/chart/" element={<PrivateRoute><ChartPage /></PrivateRoute>} />
		</Routes>
	);
};

export default App;
